module.exports = __webpack_public_path__ + "img/line.8fc311d3.jpg";